import { render, staticRenderFns } from "./ObrasNueva.vue?vue&type=template&id=864bdefe&scoped=true"
import script from "./ObrasNueva.vue?vue&type=script&lang=js"
export * from "./ObrasNueva.vue?vue&type=script&lang=js"
import style0 from "./ObrasNueva.vue?vue&type=style&index=0&id=864bdefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864bdefe",
  null
  
)

export default component.exports